import { render, staticRenderFns } from "./PhotoCard.vue?vue&type=template&id=190ec2cf&scoped=true&"
import script from "./PhotoCard.vue?vue&type=script&lang=js&"
export * from "./PhotoCard.vue?vue&type=script&lang=js&"
import style0 from "./PhotoCard.vue?vue&type=style&index=0&id=190ec2cf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190ec2cf",
  null
  
)

export default component.exports